<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false" class="card">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row>
          <a-col :span="6">
            <a-form-item label="关联编号">
              <a-input v-model="query.associateNo" placeholder="请输入关联编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="类别">
              <a-select placeholder="请选择类别" v-model="query.category" allow-clear>
                <a-select-option key="任务">任务</a-select-option>
                <a-select-option key="工单">工单</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="申请类型">
              <a-select placeholder="请选择申请类型" v-model="query.applicationType" allow-clear>
                <a-select-option key="提交任务申请">提交任务申请</a-select-option>
                <a-select-option key="发布任务申请">发布任务申请</a-select-option>
                <a-select-option key="提交工单申请">提交工单申请</a-select-option>
                <a-select-option key="派发工单申请">派发工单申请</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-item label="申请人">
              <a-input v-model="query.applicant" placeholder="请输入申请人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="申请时间">
              <a-date-picker
                v-model="query.applicationTime"
                :show-time="{ format: 'YYYY-MM-DD' }"
                format="YYYY-MM-DD"
                placeholder="请选择申请时间"
                @change="timeOnChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" style="margin-left: 22px" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
            </span>
          </a-col>
        </a-row>
        <!-- <a-row> -->
        <!-- </a-row> -->
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">详情</a>
      </span>
      <span slot="statusAction" slot-scope="text">
        <a-tag color="rgb(50, 205, 50)" v-if="text == 1"> 审批通过 </a-tag>
        <!-- <span v-if="text == 1" style="color: green">审批通过</span> -->
      </span>
    </a-table>
    <a-modal
      title="详情"
      style="top: 20px"
      :width="800"
      destroyOnClose
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
    >
      <a-form-model
        class="tenant-form"
        :model="addOrUpdateForm"
        ref="addOrUpdateForm"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-row class="form-row" type="flex" justify="center" :gutter="4">
          <a-col :md="12" :sm="24">
            <a-form-model-item label="关联编号">
              <span>{{ addOrUpdateForm.associateNo }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="类别">
              <span>{{ addOrUpdateForm.category }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="申请类型">
              <span>{{ addOrUpdateForm.applicationType }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="申请人">
              <span>{{ addOrUpdateForm.applicantName }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="申请时间">
              <span>{{ addOrUpdateForm.applicationTime }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="泵房状态" v-if="addOrUpdateForm.category !== '工单'">
              <a-tag color="rgb(50, 205, 50)" v-if="addOrUpdateForm.pumpStatus == 0"> 正常 </a-tag>
              <a-tag color="rgb(255, 99, 71)" v-if="addOrUpdateForm.pumpStatus == 1"> 异常 </a-tag>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="处理结果">
              <span>{{ addOrUpdateForm.consequence }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="处理图片">
              <div class="fileDiv">
                <ul>
                  <li class="fileLi" v-for="item in addOrUpdateForm.completeFileNames" :key="item.url">
                    <img :src="item.url" @click="fileNamesclick(item.url)" style="width: 80px; height: 80px" />
                  </li>
                </ul>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="审批结果">
              <span v-if="addOrUpdateForm.approvalStatus == 1">通过</span>
              <span v-if="addOrUpdateForm.approvalStatus == 2">未通过</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24"> </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="审批意见">
              <span>{{ addOrUpdateForm.approvalComments }}</span>
              <!-- <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.approvalComments" :rows="4" /> -->
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24"> </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal
      title="图片"
      style="top: 20px"
      :width="800"
      destroyOnClose
      v-model="fileNameshwo"
      @ok="fileNameshwocancel"
      @cancel="fileNameshwocancel"
    >
      <img :src="fileNamesimg" alt="" style="width: 100%" />
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import axios from 'axios'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 100,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '关联编号',
    dataIndex: 'associateNo',
  },
  {
    title: '类别',
    dataIndex: 'category',
  },
  {
    title: '申请类型',
    dataIndex: 'applicationType',
  },
  {
    title: '来源',
    dataIndex: 'origin',
  },
  {
    title: '申请人',
    dataIndex: 'applicantName',
  },
  {
    title: '申请时间',
    dataIndex: 'applicationTime',
  },
  {
    title: '审批状态',
    dataIndex: 'approvalStatus',
    scopedSlots: { customRender: 'statusAction' },
  },
  {
    title: '审批意见',
    dataIndex: 'approvalComments',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    // TaskModal
  },
  name: 'ApprovalPass',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/approval_managements/page',
      queryOneUrl: '/pipe-network/approval_managements',
      exportDataUrl: 'pipe-network/approval_managements/export',
      exportFileName: '审批管理表.xlsx',
      query: {
        associateNo: '',
        applicant: '',
        applicationType: undefined,
        approvalStatus: 1,
        category: undefined,
        applicationTime: '',
        sysType: '二次供水',
      },
      fileNameshwo: false,
      fileNamesimg: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        associateNo: '',
        category: '',
        applicationType: '',
        origin: '',
        applicant: '',
        applicationTime: '',
        approvalStatus: '',
        approvalComments: '',
        fileNames: '',
        completeFileNames: '',
        consequence: '',
        pumpStatus: 0,
        applicantName: '',
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + 'manager/file/resources/upload',
    }
  },
  filters: {},
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    fileNamesclick(i) {
      this.fileNamesimg = i
      this.fileNameshwo = true
    },
    fileNameshwocancel() {
      this.fileNameshwo = false
      this.fileNamesimg = ''
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      let index = this.addOrUpdateForm.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.addOrUpdateForm.fileNames.splice(index, 1)
    },
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .delete(_this.deleteUrl, { data: _this.selectedRows })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.selectedRows.length = ''
                console.log(_this.selectedRows.length, 'llll')
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          console.log(_this.selectedRows.length, 'lll')
          _this.$message.info('已取消删除')
        },
      })
    },
    // 重置
    resetList() {
      this.query = {
        associateNo: '',
        applicant: '',
        applicationType: undefined,
        approvalStatus: 1,
        category: undefined,
        applicationTime: '',
        sysType: '二次供水',
      }
      this.pagination.current = 1
      this.queryList()
    },
    addOrUpdateHandle(id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              console.log(this.addOrUpdateForm)
            })
            .catch(() => {})
        }
      })
    },

    approveHandle() {
      console.log('审批')
    },
    goDetails() {},
    selectChange(value) {},
    timeOnChange(date, dateString) {
      this.query.applicationTime = dateString
    },
    handleCancel() {},
    onOk(value) {},
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-row {
  margin: 0;
  margin-left: 24px;
  margin-right: 24px;
}
.card {
  width: 80%;
  height: 80%;
  // background: firebrick;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
